module.exports = __webpack_public_path__ + "img/spawner-die-02.8ac4c36e.png";